import { jsx as _jsx } from "react/jsx-runtime";
import { SignInFlow } from "@descope/react-sdk";
export function Login() {
    return _jsx(SignInFlow, { onSuccess: (e) => {
            console.log(e);
        }, onError: (e) => console.log(e), redirectUrl: location.href });
}
//# sourceMappingURL=Login.js.map